import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Input from '../../components/ui/Input';
import Button from '../../components/ui/Button';
import Select from '../../components/ui/Select';

const PaymentForm: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  
  const [invoiceNumber, setInvoiceNumber] = useState('');
  const [customer, setCustomer] = useState('');
  const [account, setAccount] = useState('');
  const [amount, setAmount] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('');
  const [date, setDate] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Mock data for editing existing payment
  React.useEffect(() => {
    if (id) {
      // In a real implementation, we would fetch the payment data from the database
      // For now, we'll just set some mock data
      setInvoiceNumber('INV-00245');
      setCustomer('John Doe');
      setAccount('Cash');
      setAmount('1250000');
      setPaymentMethod('Cash');
      setDate('2023-06-15');
    }
  }, [id]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    try {
      setError('');
      setLoading(true);
      
      // In a real implementation, we would save the payment to the database
      // For now, we'll just simulate a delay
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      navigate('/payments');
    } catch (err) {
      setError('Failed to save payment');
    }
    
    setLoading(false);
  };

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">
          {id ? 'Edit Payment' : 'Add New Payment'}
        </h1>
      </div>

      <div className="card">
        <form onSubmit={handleSubmit} className="px-4 py-5 sm:p-6">
          {error && (
            <div className="mb-6 bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded relative">
              {error}
            </div>
          )}

          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
            <Input
              label="Invoice Number"
              type="text"
              value={invoiceNumber}
              onChange={(e) => setInvoiceNumber(e.target.value)}
              required
            />

            <Input
              label="Customer"
              type="text"
              value={customer}
              onChange={(e) => setCustomer(e.target.value)}
              required
            />

            <Input
              label="Account"
              type="text"
              value={account}
              onChange={(e) => setAccount(e.target.value)}
              required
            />

            <Input
              label="Amount"
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              min="0"
              step="1000"
              required
            />

            <Select
              label="Payment Method"
              value={paymentMethod}
              onChange={(e) => setPaymentMethod(e.target.value)}
              options={[
                { value: '', label: 'Select Payment Method' },
                { value: 'cash', label: 'Cash' },
                { value: 'bank_transfer', label: 'Bank Transfer' },
                { value: 'credit_card', label: 'Credit Card' },
                { value: 'other', label: 'Other' },
              ]}
              required
            />

            <Input
              label="Date"
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              required
            />
          </div>

          <div className="mt-8 flex justify-end space-x-3">
            <Button
              type="button"
              variant="outline"
              onClick={() => navigate('/payments')}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="primary"
              disabled={loading}
            >
              {loading ? 'Saving...' : 'Save Payment'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PaymentForm;